import { app_url } from 'app_config';
import Breadcrumb from 'components/Common/Breadcrumb';
import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Container, CardBody, Card, Col, Row } from "reactstrap"

import AllSingleItems from '../Single Item Master';
import { usePermissionData } from 'AppContext';

const FinanceMaster = () => {

    const { tab_name } = useParams()
    const navigate = useNavigate()

    const { checkAccess, permissions } = usePermissionData()

    const [tabs, setTabs] = useState([]);

    useEffect(() => {
        if (permissions) {
            const newTabs = [];
            if (checkAccess(19, 'view')) newTabs.push("invoicing-method");
            if (checkAccess(20, 'view')) newTabs.push("payment-method");

            setTabs(newTabs); // Update the state with the new array 
        }
    }, [permissions])

    useEffect(() => {
        if (!tab_name && tabs.length) {
            navigate(`${app_url}master/finance-master/${tabs[0]}`)
        }
    }, [tab_name, tabs])

    useEffect(() => {
        document.title = "Finance Master | Peacock Accountants Limited";
    }, [])

    return (
        <div>
            <div className="page-content mb-5">
                <Container fluid>
                    <Breadcrumb title={"Dashboard"} breadcrumbItem={"Finance Master"} />
                    <div>
                        <Row>
                            <Col md={2} className='pe-1'>
                                <Card>
                                    <CardBody className=' rounded custom_side_nav p-2'>
                                        {
                                            tabs.map((tab) => {
                                                return (
                                                    <div key={tab} className='mb-2'>
                                                        <Link
                                                            to={`${app_url}master/finance-master/${tab}`}
                                                            className={`side_navlink text-capitalize ${tab === tab_name && 'bg-white fw-bold'}`}
                                                        >

                                                            {tab.replaceAll('-', ' ')}</Link>
                                                    </div>
                                                )
                                            })
                                        }
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col md={10}>
                                <Card>
                                    <CardBody>
                                        {
                                            (tab_name === 'invoicing-method') &&
                                            <AllSingleItems
                                                api_name={"invoicing-method"}
                                                heading={"Invoicing Method"}
                                                title={"Invoicing Method"}
                                                fieldName={"invoicingMethod"}
                                                module_id={19}
                                            />
                                        }

                                        {
                                            (tab_name === 'payment-method') &&
                                            <AllSingleItems
                                                api_name={"payment-method"}
                                                heading={"Payment Method"}
                                                title={"Payment Method"}
                                                fieldName={"paymentMethod"}
                                                module_id={20}
                                            />
                                        }

                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </div>
                </Container>
            </div>
        </div>
    )
}

export default FinanceMaster